import { MenuItem, SubMenu } from "react-pro-sidebar";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import expenses from "../../../images/newDesign/expenses.svg";
import { isLinkActive } from "../../sidebar/Sidebar.shared";
import { constants } from "../../../common/constants/constants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CacheData from "../../../common/utils/cacheData";
import BllinkTime from "../../../common/utils/time";

/**
 * @return {JSX.Element|null}
 * @constructor
 */
export default function ExpensesSidebarMenu({buildingId}) {
    const { t } = useTranslation();
    const currentYear = BllinkTime.getCurrentYear();
    const currentMonth = BllinkTime.getCurrentMonth();
    const localBuildingId = useSelector(state => buildingId ?? state.buildings.buildingID ?? CacheData.fetchCache('currentBuilding'));

    return (
        <SubMenu
            title={t('buildings.nav_bar_expenses')}
            icon={<img src={expenses} alt={t('buildings.nav_bar_expenses')} />}>
            <MenuItem
                active={isLinkActive(`/${constants.pages.setExpenseUrl}/${localBuildingId}`)}
                className="mobile-hide"
            >
                <OverlayTrigger
                    placement="top"
                    overlay={props => (
                        <Tooltip {...props}>
                            {t('expenses.expense_record_tooltip')}
                        </Tooltip>
                    )}
                >
                    <NavLink
                        className="nav-link"
                        to={`/${constants.pages.setExpenseUrl}/${localBuildingId}`}
                    >
                        {t('buildings.nav_bar_record_an_expense')}
                    </NavLink>
                </OverlayTrigger>
            </MenuItem>
            <MenuItem
                active={isLinkActive(`/${constants.pages.monthlyExpensesUrl}/:buildingID/:months/:year`)}
            >
                <NavLink
                    className="dropdown-link"
                    to={`/${constants.pages.monthlyExpensesUrl}/${localBuildingId}/${currentMonth}/${currentYear}`}
                >
                    {t('buildings.nav_bar_reports_expenses')}
                </NavLink>
            </MenuItem>
        </SubMenu>
    )
}
